import { useSelector } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { IStore } from "../../DataTypes/storeTypes";
import { PaymentFormInjected } from "./PaymentForm";

export default function StripeWrapper() {
    const { stripePublishableKey: stripeKey } = useSelector((state: IStore) => state.initialSettings.organisationInfo);

    const stripeAccount = useSelector((state: IStore) => state.initialSettings.clientStripeAccount);

    const stripePromise = loadStripe(stripeKey, {
        stripeAccount: stripeAccount,
    });

    return (
        <Elements stripe={stripePromise}>
            <ElementsConsumer>
                {({ stripe, elements }) => <PaymentFormInjected stripe={stripe} elements={elements} />}
            </ElementsConsumer>
        </Elements>
    );
}
